/** Bank account (ACH debit) entry with the recurring debit authorization. */
import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { btnPrimary, errorText, inputCls } from '../finance/financeUi';
import { Checkbox } from '../ui/checkbox';

export function BankForm({ onSaved }) {
  const [f, setF] = useState({ holder_name: '', routing_number: '', account_number: '', consent: false });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { onSaved(await api.request('/me/billing/bank', { method: 'POST', body: JSON.stringify(f) })); } catch (err) { toast.error(errorText(err)); } finally { setBusy(false); }
  };
  return (
    <form className="space-y-2" onSubmit={save} data-testid="bank-form">
      <input className={inputCls} placeholder="Account holder name" value={f.holder_name} onChange={set('holder_name')} data-testid="bank-holder" />
      <div className="grid grid-cols-2 gap-2">
        <input className={inputCls} placeholder="Routing number (9 digits)" inputMode="numeric" value={f.routing_number} onChange={set('routing_number')} data-testid="bank-routing" />
        <input className={inputCls} placeholder="Account number" inputMode="numeric" value={f.account_number} onChange={set('account_number')} data-testid="bank-account" />
      </div>
      <label className="flex items-start gap-2 text-xs text-muted-foreground">
        <Checkbox checked={f.consent} onCheckedChange={(v) => setF({ ...f, consent: !!v })} data-testid="bank-consent" />
        <span>I authorize Merchant Solutions Corp to debit this account for my setup fee, equipment and monthly subscription, as shown on this page, until I cancel in writing.</span>
      </label>
      <button type="submit" className={btnPrimary} disabled={busy} data-testid="bank-save-btn">Save bank account</button>
    </form>
  );
}
